var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudBottomLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 40,
    viewBox: "0 0 143 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M97.2897 0.590141C84.0241 -1.76183 69.0005 3.10248 62.5542 11.8689C58.1856 8.12714 50.3008 6.73734 44.0676 8.71514C37.8344 10.6929 33.7855 15.7711 34.5847 20.6354C26.2204 14.1674 9.54523 15.1831 2.77927 22.5597C0.0622253 25.4997 -1.0565 29.5087 1.23433 32.6625C4.48412 36.9923 12.4221 37.8475 19.2413 38.0613C52.272 39.2908 80.2416 40.5202 112.58 39.7719C121.317 39.5581 143.053 39.7719 143 29.9898C142.947 20.8492 129.042 18.0161 121.264 21.8648C119.719 12.0827 110.928 2.99557 97.2897 0.590141Z",
    fill: "#3E809D",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBottomLeft);
export default __webpack_public_path__ + "static/media/cloud-bottom-left.9b45fdb78e513704e8c7da68158eb6e2.svg";
export { ForwardRef as ReactComponent };